import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useSelector } from 'react-redux';
import { getHeadLinks, getHeadMeta, getHeadScript, getHeadStyle, getTitle } from './redux/selectors';
const DaScript = (_param)=>{
    var { _inlineContent } = _param, scriptProps = _object_without_properties(_param, [
        "_inlineContent"
    ]);
    if (_inlineContent) {
        return /*#__PURE__*/ React.createElement("script", _object_spread_props(_object_spread({}, scriptProps), {
            dangerouslySetInnerHTML: {
                __html: _inlineContent
            }
        }));
    }
    return /*#__PURE__*/ React.createElement("script", scriptProps);
};
const DaStyle = (_param)=>{
    var { _inlineContent } = _param, styleProps = _object_without_properties(_param, [
        "_inlineContent"
    ]);
    if (_inlineContent) {
        return /*#__PURE__*/ React.createElement("style", _object_spread_props(_object_spread({
            type: "text/css"
        }, styleProps), {
            dangerouslySetInnerHTML: {
                __html: _inlineContent
            }
        }));
    }
    return /*#__PURE__*/ React.createElement("style", _object_spread({
        type: "text/css"
    }, styleProps));
};
const DaTitle = ()=>{
    const title = useSelector(getTitle);
    const duper = useSelector((state)=>{
        var _state_DUPERBROWSE_streamStack, _state_DUPERBROWSE;
        var _state_DUPERBROWSE_streamStack_length;
        return (_state_DUPERBROWSE_streamStack_length = (_state_DUPERBROWSE = state['@@DUPERBROWSE']) === null || _state_DUPERBROWSE === void 0 ? void 0 : (_state_DUPERBROWSE_streamStack = _state_DUPERBROWSE.streamStack) === null || _state_DUPERBROWSE_streamStack === void 0 ? void 0 : _state_DUPERBROWSE_streamStack.length) !== null && _state_DUPERBROWSE_streamStack_length !== void 0 ? _state_DUPERBROWSE_streamStack_length : 0;
    });
    return /*#__PURE__*/ React.createElement("title", {
        key: `t-${duper}`
    }, title);
};
const Head = ()=>{
    const links = useSelector(getHeadLinks);
    const meta = useSelector(getHeadMeta);
    const script = useSelector(getHeadScript);
    const style = useSelector(getHeadStyle);
    return /*#__PURE__*/ React.createElement("head", null, /*#__PURE__*/ React.createElement(DaTitle, null), links && links.map((l, index)=>/*#__PURE__*/ React.createElement("link", _object_spread({
            key: `link${index}`
        }, l))), meta && meta.map((m, index)=>/*#__PURE__*/ React.createElement("meta", _object_spread({
            key: `meta${index}`
        }, m))), script && script.map((s, index)=>/*#__PURE__*/ React.createElement(DaScript, _object_spread({
            key: `script${index}`
        }, s))), style && style.map((s, index)=>/*#__PURE__*/ React.createElement(DaStyle, _object_spread({
            key: `style${index}`
        }, s))));
};
Head.displayName = 'Head';
export default Head;

//# sourceMappingURL=Head.js.map